import {
  calculateEnvironmentalScore,
  isEnvironmentalRequirementsConfigured,
} from './cvss-environmental';
import type { CvssEnvironmentalRequirements } from './cvss-environmental-types';
import type { CvssSeverity } from './cvss-types';
import {
  calculateCvssBaseScoreFromVector,
  getSeverityFromScore,
} from './cvss-utils';

export type FindingCvssDisplayScore = {
  baseScore: number;
  displayedScore: number;
  displayedSeverity: CvssSeverity;
};

export const calculateFindingCvssDisplayScore = ({
  vector,
  environmentalRequirements,
}: {
  vector: string;
  environmentalRequirements?: Partial<CvssEnvironmentalRequirements> | null;
}): FindingCvssDisplayScore | null => {
  const baseScore = calculateCvssBaseScoreFromVector(vector);

  if (baseScore === null) {
    return null;
  }

  const version = vector.startsWith('CVSS:4.0/')
    ? '4.0'
    : vector.startsWith('CVSS:3.')
      ? '3.1'
      : null;
  const environmental =
    version && isEnvironmentalRequirementsConfigured(environmentalRequirements)
      ? calculateEnvironmentalScore({
          version,
          baseVector: vector,
          requirements: environmentalRequirements,
        })
      : null;
  const displayedScore = environmental?.effectiveScore ?? baseScore;

  return {
    baseScore,
    displayedScore,
    displayedSeverity: getSeverityFromScore(displayedScore),
  };
};
